import { Videotape } from 'lucide-react';
import React from 'react';
import { LinkInfo } from '../../models/link';
import FullScreenError from '../../shared/components/FullScreenError';
import FullScreenLoader from '../../shared/components/FullScreenLoader';
import { InfoPlate } from '../../shared/components/InfoPlate';
import { useGetLink } from '../../shared/hooks/useGetLink';
import { usePlatformsInstruction } from '../../shared/hooks/usePlatformInstruction';
import { getOs } from '../../shared/utils/platformUtils';
import { SetupVpnCard } from './SetupVpnCard';
import './SetupVpnScreen.css';

const SetupVpnScreen: React.FC = () => {

    const { link, isLoading: isLoadingLink, error: linkError } = useGetLink();

    if (linkError) {
        return <FullScreenError />;
    }

    if (isLoadingLink || !link) {
        return <FullScreenLoader />;
    }

    return <PlatformsContent link={link} />;
};

const PlatformsContent: React.FC<{ link: LinkInfo }> = ({ link }) => {

    const userPlatform = getOs();
    const { platforms, loading: isLoadingPlatforms } = usePlatformsInstruction(link);

    const sortedCards = [...platforms].sort((a, b) => {
        const aMatch = a.match.includes(userPlatform);
        const bMatch = b.match.includes(userPlatform);
        return Number(bMatch) - Number(aMatch); // matched карточка идёт выше
    });

    const firstMatchId = sortedCards.find((c) => c.match.includes(userPlatform))?.id;


    if (isLoadingPlatforms)
        return <FullScreenLoader />

    return (
        <>
            <h2>Инструкция по настройке</h2>

            <InfoPlate>
                <div key="platform-info">
                    {userPlatform === 'unknown' ?
                        <>
                            Мы не смогли автоматически определить вашу операционную систему.
                            <p />
                            Выберите инструкцию для вашей платформы из списка.
                        </>
                        :
                        <>
                            Мы автоматически обнаружили вашу платформу: <b>{userPlatform}</b>
                            <p />
                            Если это не так, пожалуйста, выберите вашу ОС вручную.
                        </>
                    }
                </div>
                <div key="video-info">
                    Вы можете посмотреть видео-инструкцию для платформы, нажав на <Videotape size={17} /> иконку
                </div>
            </InfoPlate>
            <div style={{ paddingBottom: '30px' }}></div>

            {sortedCards.map((card) => (
                <SetupVpnCard
                    key={card.id}
                    autoExpand={card.id === firstMatchId}
                    platform={card.platform}
                    iconName={card.iconName}
                    providers={card.providers}
                />
            ))}
        </>
    );
};

export default SetupVpnScreen;